import { isEqual } from "lodash";
import { useState } from "react";
import { EmployeeGroupQuickFilter } from "./interfaces";

import useAbortableLoadResponse from "../../../custom-hooks/useAbortableLoadResponse/useAbortableLoadResponse";
import { EmployeeGroupDTO } from "../../../models/employee-groups";
import { EmployeeGroupsApiService } from "../../../services/employee-groups/employee-groups-api.service";

export const useEmployeeGroupQuickFilter = (allEmployeeGroupsAsDefault = false) => {
  const { response } = useAbortableLoadResponse<EmployeeGroupDTO>(EmployeeGroupsApiService, {
    sorts: undefined, // so that service API default sort is applied
    page: { pageNumber: 0, pageSize: 100 },
  });

  const [quickFilter, setQuickFilter] = useState<EmployeeGroupQuickFilter>({
    employeeGroups: {
      employeeGroupIds: allEmployeeGroupsAsDefault ? [] : [...(response?.items[0]?.id ? [response?.items[0].id] : [])],
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof EmployeeGroupQuickFilter,
    value: EmployeeGroupQuickFilter["employeeGroups"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    employeeGroupQuickFilter: quickFilter,
    setEmployeeGroupQuickFilter: handleChangeQuickFilter,
  };
};
